import { getFileName } from "@helpers/getFileName"
import { totalContentV3QueryRequests } from "@sop/FuelPage/Total/totalContentV3QueryRequests"
import { useQuery } from "@tanstack/react-query"
import { requestApi2 } from "@utils/http"
import { Facility, GetAllFacilitiesArgs, endpoints } from "api"

export function useGetFacilitiesRadiusQuery(args: {
	isFacilitiesFeatureAvailable: boolean
	types: GetAllFacilitiesArgs["types"]
}) {
	const res = useQuery(
		{queryKey: [
			`source=${getFileName()}`,
			`queryId=GetFacilitiesRadius`,
			`endpoints=[${endpoints.getFacilities.getName()}]`,
			`facilityTypes=${args.types}`,
			`isFacilitiesFeatureAvailable=${args.isFacilitiesFeatureAvailable}`,
		],
		queryFn: async (): Promise<Facility[] | null> => {
			if (args.isFacilitiesFeatureAvailable === false) {
				return []
			}
			const facilities = await requestApi2(endpoints.getFacilities, { types: args.types })
			return facilities === null
				? null
				: facilities.sort((a, b) => (a.id > b.id ? 1 : a.id < b.id ? -1 : 0))
		},
			staleTime: 60 * 60 * 1000,
			refetchInterval: 60 * 60 * 1000,
			enabled: totalContentV3QueryRequests.getFacilitiesRadius.enable,
		}
	)
	return res
}
